export { getStaticProps } from 'ui/pages/blog'
export { default } from 'ui/pages/blog';
